const applePayRequest = {
  canMakePayments: function() {
    return window.ApplePaySession && window.ApplePaySession.canMakePayments()
  },
  creatSession: function({ data, validateURL, payMethodShortNo, submit }) {
    // requestApplePayPaymentSession: 传递参数validationURL给后端，获取apple pay payment session
    var request = {
      supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      merchantCapabilities: ['supports3DS'],
      supportedCountries: ['AE', 'SA', 'QA', 'BH', 'OM', 'KW'],
      ...data,
    }
    var session = new window.ApplePaySession(3, request)
    session.onvalidatemerchant = function(event) {
      // 验证validateURL
      validateURL({
        payMethodShortNo,
        params: { validationURL: event.validationURL },
      }).then((res) => {
        console.log('onvalidatemerchant', res)
        if (res.payload.extension) {
          session.completeMerchantValidation(res.payload.extension)
        } else {
          session.completePayment({
            status: window.ApplePaySession.STATUS_FAILURE,
          })
        }
      })
    }
    session.onpaymentauthorized = (event) => {
      console.log('onpaymentauthorized', JSON.stringify(event))
      submit({
        method: 'PAY_WITH_DEVICE',
        devicePayInfo: {
          paymentToken: JSON.stringify(event.payment.token.paymentData),
          decryptType: 'MERCHANT_DECRYPT',
          cardNoSuffix: event.payment.token.paymentMethod.displayName.replace(/[^0-9]/g, ''),
        },
        payMethodShortNo,
      }).then((res) => {
        const status = res.payload.paymentOrderNo
          ? window.ApplePaySession.STATUS_SUCCESS
          : window.ApplePaySession.STATUS_FAILURE
        const result = {
          status,
        }
        session.completePayment(result)
      })
    }
    session.begin()
  }
}

export default applePayRequest
